import { styled } from '@elliemae/ds-system';

export const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
`;

export const MenuWrapper = styled.div`
  position: relative;
  height: 100%;
`;

export const Menu = styled.div`
  position: fixed;
  width: 80%;
  height: 100%;
  background-color: ${(props) => props.theme.colors.brand[700]};
  font-family: ${(props) => props.theme.fonts.default};
  box-shadow: 5px 0 5px ${(props) => props.theme.colors.neutral[600]};
  padding: ${(props) => props.theme.space.xs};
  z-index: ${({ theme }) => theme.zIndex.backdrop + 1};
`;

export const Heading = styled.div`
  display: flex;
  flex-direction: row;

  .content {
    width: 100%;
    display: flex;
    flex-direction: row;
    span {
      flex-grow: 1;
    }
    label {
      padding-top: 1px;
      line-height: 30px;
      font-weight: ${(props) => props.theme.fontWeights.semibold};
      font-size: 22px;
      color: ${(props) => props.theme.colors.neutral['000']};
    }
    .icon {
      cursor: pointer;
      padding-top: 6px;
    }
  }
`;

export const Icon = styled.div`
  margin-right: ${(props) => props.theme.space.xxs2};
`;

export const Hr = styled.hr`
  margin-left: -${(props) => props.theme.space.xs};
  margin-right: -${(props) => props.theme.space.xs};
`;
export const MenuList = styled.div`
  .menuitem {
    display: flex;
    flex-direction: row;
    cursor: pointer;
    height: 22px;
    margin-bottom: ${(props) => props.theme.space.xs};
    .icon {
      padding-left: 6px;
      margin-right: ${(props) => props.theme.space.xs};
      span {
        height: 20px;
        width: 20px;
        svg {
          height: 20px;
          width: 20px;
        }
      }
    }
    .text {
      font-weight: ${(props) => props.theme.fontWeights.regular};
      font-size: 18px;
      line-height: 22px;
      color: ${(props) => props.theme.colors.neutral['000']};
      &.active {
        font-weight: ${(props) => props.theme.fontWeights.semibold};
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const BottomMenu = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;
